module.exports = "  <div class='panel panel-primary'>  \r\n    <div class='panel-heading'>\r\n        <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/{{pageTitle}}\r\n    </div>\r\n    <div class='panel-body' *ngIf=\"setHubSizesResult?.message==''\" align=\"center\">\r\n        <i style=\"color:blue\" class=\"fa fa-spinner fa-spin fa-5x\"> </i>\r\n        <div>Loading please wait ....</div>\r\n    </div>\r\n    <div  *ngIf=\"setHubSizesResult?.message!=''\">\r\n        Message: {{ setHubSizesResult?.message }}\r\n    </div>\r\n</div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./app/system-management/growth-rates/set-hub-sizes/set-hub-sizes.component.html
 ** module id = 839
 ** module chunks = 0
 **/